import { LocationElements } from '../../../location-element';
import { ILocationConfigUnit } from '../../../../models/location-config.interface';
import { MAP_ADDRESS_TYPES } from '../../../../../../../shared/constants/map-address-types';
import { CmxMapConfig } from '../../../../../../../shared/models/cmx-map-config/cmx-map-config';

import { ILocationMapState } from '../../../../reducers/location-map-reducer/location-map.reducer';

import { JobsiteSetCommand } from '../../../../services/commands/jobsite/jobsite-set.command';
import { JobsiteLoadAddressCommand } from '../../../../services/commands/jobsite/jobsite-load-address.command';
import { JobsiteLoadSalesAreaCommand } from '../../../../services/commands/jobsite/jobsite-load-sales-area.command';
import { PurchaseOrderSetCommand } from '../../../../services/commands/purchase-order/purchase-order-set.command';
import { SpecialInstructionsSetCommand } from '../../../../services/commands/special-instructions/special-instructions-set.command';

import { JobsiteLoadAddressEffects } from '../../../../effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteLoadSalesAreaEffects } from '../../../../effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { PurchaseOrderMandatoryEffects } from '../../../../effects/purchase-order-effects/purchase-order-mandatory.effects';
import { JobsiteRenderMapEffects } from '../../../../effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { JobsiteLoadEffects } from '../../../../effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { PointOfDeliverySetCommand } from '../../../../services/commands/point-of-delivery/pod-set.command';
import { PointOfDeliveryLoadAddressCommand } from '../../../../services/commands/point-of-delivery/pod-load-address.command';
import { PointOfDeliveryLoadSalesAreaCommand } from '../../../../services/commands/point-of-delivery/pod-load-sales-area.command';
import { PointOfDeliveryLoadEffects } from '../../../../effects/point-of-delivery-effects/pod-load-effects/point-of-delivery-load.effects';
import { PointOfDeliveryLoadAddressEffects } from '../../../../effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address.effects';
import { PointOfDeliveryRenderMapEffects } from '../../../../effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-render-map.effects';
import { PointOfDeliveryLoadSalesAreaEffects } from '../../../../effects/point-of-delivery-effects/pod-load-sales-area/point-of-delivery-load-sales-area.effects';
import { Validators } from '@angular/forms';
import { MAX_LENGTH_PO } from '../../../../constants/purchase-order.constants';

export const delivery: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } = {
  fields: [
    {
      name: LocationElements.JOBSITE,
      visible: true,
      disabled: false,
      required: true,
      onChange: [JobsiteSetCommand, JobsiteLoadAddressCommand, JobsiteLoadSalesAreaCommand],
      dynamicEffects: [
        JobsiteLoadEffects,
        JobsiteLoadAddressEffects,
        JobsiteRenderMapEffects,
        JobsiteLoadSalesAreaEffects,
      ],
    },
    {
      name: LocationElements.POINT_OF_DELIVERY,
      visible: true,
      disabled: false,
      required: true,
      onChange: [PointOfDeliverySetCommand, PointOfDeliveryLoadAddressCommand, PointOfDeliveryLoadSalesAreaCommand],
      dynamicEffects: [
        PointOfDeliveryLoadEffects,
        PointOfDeliveryLoadAddressEffects,
        PointOfDeliveryRenderMapEffects,
        PointOfDeliveryLoadSalesAreaEffects,
      ],
    },
    {
      name: LocationElements.PURCHASE_ORDER,
      visible: true,
      disabled: false,
      required: false,
      onChange: [PurchaseOrderSetCommand],
      dynamicEffects: [PurchaseOrderMandatoryEffects],
      validators: [Validators.maxLength(MAX_LENGTH_PO)],
    },
    {
      name: LocationElements.SPECIAL_INSTRUCTION,
      visible: true,
      disabled: false,
      required: false,
      maxlength: 500,
      onChange: [SpecialInstructionsSetCommand],
    },
  ],
  mapConfig: {
    showMap: false,
    config: new CmxMapConfig(null, MAP_ADDRESS_TYPES.JOBSITE),
  },
};
